import type { RouteRecordRaw } from 'vue-router'

import { registerOrpheusMessages } from './i18n'

import { useLocaleStore } from '@/shared/i18n'

export const ORPHEUS_ROUTE = { name: 'Orpheus' } as const

export const orpheusRoutes: RouteRecordRaw[] = [
  {
    path: 'orpheus',
    name: ORPHEUS_ROUTE.name,
    component: () => import('./components/OrpheusPage.vue'),
    meta: {
      requiresAuth: true,
      permission: 'orpheus',
      navKey: 'orpheus',
      titleKey: 'orpheus.title',
      appSidebar: 'hidden',
      contentInset: 'none',
    },
    beforeEnter: () => registerOrpheusMessages(useLocaleStore().locale),
  },
]
